
import Reserve from "../../../assets/filled/Reserve.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ReserveIcon({ className, dataTestid = "ReserveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Reserve data-testid={dataTestid} className={classes} {...rest} />
  );
}
